// removed by extract-text-webpack-plugin
module.exports = {"icon":"AddFilterBox__icon___1EHi8","addText":"AddFilterBox__addText___PQ8Fr","addFilterContainer":"AddFilterBox__addFilterContainer___2F9b3","addIcon":"AddFilterBox__addIcon___3ST5j"};


//////////////////
// WEBPACK FOOTER
// ./src/routes/admin/companies/components/AddFilterBox.scss
// module id = 1675
// module chunks = 0